var exports = {
  "kL": "xe7b6e3d6--f478de--container",
  "wx": "xe7b6e3d6--f478de--header",
  "M1": "xe7b6e3d6--f478de--stats",
};

module.exports = exports;
